import { takeLatest, put, select, call } from 'redux-saga/effects';
import actions from '../actions';
import { getInterpreterCache, waitForInterpreterToFinish, interpretFileData } from './interpreter';
import ProbingInterpreter from '../probing/interpreter';
import machines from '../machines';

export function* handleProbingUpdate() {
  const machine = machines[yield select( (state) => state.machineState.machine )];

  yield put(actions.machineState.kinematicsMode.setTrivial());
  yield put(actions.machineState.tool.set(14));
  yield put(actions.machineState.tool.change());
  yield put(actions.machineState.tool.setToolLengthOffset({ H: 14 }));

  const probingProgram = yield select( (state) => state.probing.program );
  const probingActiveOperation = yield select ( (state) => state.probing.activeOperation );
  const probingInterpreter = new ProbingInterpreter(probingProgram, machine);
  const gcodeLines = [];
  probingInterpreter.gcodeLines.forEach((chunk) => {
    gcodeLines.push(...chunk);
  });
  yield call(interpretFileData, gcodeLines);
  yield call(waitForInterpreterToFinish);

  const interpreterCache = yield call(getInterpreterCache);
  const toolPaths = interpreterCache.toolPaths;
  const lineAtEndOfProbingOperation = toolPaths[probingActiveOperation+2]-1;
  const currentTime = interpreterCache.timeAtLine(lineAtEndOfProbingOperation);
  const machineState = interpreterCache.machineStateAtLineAndTime(lineAtEndOfProbingOperation, currentTime);
  yield put(actions.machineState.set(machineState));
  yield put(actions.interpreter.setCurrentLineAndTimeNoUpdates({ currentLine: lineAtEndOfProbingOperation, currentTime }));
}

export default function* probingSaga() {
  yield takeLatest([ actions.probing.updateOperation ], handleProbingUpdate);
};
